import Vue from "vue";
import Vuex from "vuex";

import cellArray from "./cellArray";
import room from "./room";
import sound from "./sound";
import player from "./player";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    browser: '',
    appOutDated: false,
    sounds: null,
    loading: false,
    timer: 0,
    roomListLoading: false,
    mainRoomLoaded: false,
    loadingText: '',
    strikedCells: [],
    boardWidth: 200,
    boardHeight: 200,
    boardOffset: 5,
    howToPlayModal:false,
    roomIdFromLink:false,
    invalidLink:false,
    downloadAppModal:false
  },
  mutations: {},
  actions: {},
  modules: {
    cellArray,
    room,
    player,
    sound
  }
});
